import { formatDateForPageHeader } from "../../../functions/date";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { MdToday } from "react-icons/md"
import './WeekHeader.css'

interface WeekHeaderProps {
  startDate: Date;
  endDate: Date;
  onPrevWeek: () => void; // callback for previous week
  onNextWeek: () => void; // callback for next week
}

const WeekHeader: React.FC<WeekHeaderProps> = ({
  startDate,
  endDate,
  onPrevWeek,
  onNextWeek,
}) => {
  const now = new Date()
  const isCurrentWeek = now > startDate && now < endDate

  return (
    <div className="week-header">
      <div className="week-header-left">
        <button className="week-nav-button" onClick={onPrevWeek}>
          <FiChevronLeft />
        </button>
        <button className="week-nav-button web-only" onClick={onNextWeek}>
          <FiChevronRight />
        </button>
      </div>
      <div className="week-header-left">
        <p className={ `week-header-text ${ isCurrentWeek ? "current-week" : ""}` } >
          <span>
            {formatDateForPageHeader(startDate)} - {formatDateForPageHeader(endDate, true)}
          </span>
        </p>
      </div>
      <div className="week-header-right">
        <div className="web-only" style={{ width: 24 }} />{" "}
        {/* spacer to balance layout in web view */}
        <button className="week-nav-button mobile-only" onClick={onNextWeek}>
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
};

export default WeekHeader;